// src/services/api/adminAxios.js
import axios from 'axios';
import CryptoJS from "crypto-js";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
const SECRET = process.env.REACT_APP_CRYPTO_SECRET;

if (!SECRET) {
  throw new Error("❌ REACT_APP_CRYPTO_SECRET missing in .env");
}

const adminAxios = axios.create({ baseURL: `${API_URL}/admin` });
const key = CryptoJS.SHA256(SECRET);
const iv = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

// 🔐 ENCRYPT (Aligned with Backend Decryptor)
const encrypt = (data) => {
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    key,
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );
  return { data: encrypted.toString() };
};

// 🔓 DECRYPT
const decrypt = (payload) => {
  if (!payload) return payload;
  const target = payload?.data !== undefined ? payload.data : payload;
  if (!target || typeof target !== 'string') return payload;
  const decrypted = CryptoJS.AES.decrypt(
    target,
    key,
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
};

// Request Interceptor
adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token && token !== "undefined" && token !== "null") {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }
  if (config.method?.toLowerCase() === "get") return config;
  if (config.data instanceof FormData) return config;

  if (config.data) {
    const encryptedPayload = encrypt(config.data);
    config.headers["x-encrypted-data"] = JSON.stringify(encryptedPayload);
    config.data = {};
  }
  return config;
});

// Response Interceptor
adminAxios.interceptors.response.use(
  (response) => {
    try {
      if (response.data?.encrypted && response.data?.data) {
        const decrypted = decrypt(response.data.data);
        response.data = JSON.parse(decrypted);
      } else if (typeof response.data?.data === "string" && response.data?.data.length > 20) {
        const decrypted = decrypt(response.data.data);
        response.data = JSON.parse(decrypted);
      }
    } catch (err) {
      console.error("❌ Decryption failed:", err.message);
    }
    return response;
  },
  (error) => Promise.reject(error)
);

export default adminAxios;
